/**
 * A legenda que vale a pena mostrar embaixo de uma imagem no chat.
 *
 * A imagem já está na tela. Texto embaixo dela só ajuda quando diz algo que a
 * imagem não diz -- "segue o print do erro" ajuda; "image.png" não.
 *
 * ## Os dois tipos de ruído, e de onde cada um vem
 *
 * 1. NOME DE ARQUIVO. Quando o operador anexa sem escrever nada, o campo de
 *    mensagem recebe o nome do arquivo. Esta regra já existia aqui.
 *
 * 2. MARCADOR DE MÍDIA (`[imagem]`). Vem da API, de
 *    `ProcessarMensagemDoWhatsApp::textoParaOChat()`. Ele existe para o caso em
 *    que NÃO conseguimos baixar o arquivo -- aí "chegou uma imagem, não está
 *    aqui" é a única informação disponível, e é informação valiosa.
 *
 *    Mas quando o download deu certo, a imagem aparece, e o marcador vira
 *    rótulo em cima do que já está à vista. Encontrado no teste real de
 *    22/09/2026, com o usuário olhando a própria tela.
 *
 * ## Por que a regra mora aqui e não na API
 *
 * O marcador é dado honesto: é o que a API sabe sobre a mensagem, e ele vai
 * junto para a transcrição do chamado. Quem decide não REPETI-LO ao lado da
 * imagem é a tela -- que é quem sabe que a imagem está sendo exibida.
 *
 * Esta função não conhece o caso da mídia que NÃO baixou, e não precisa: ali
 * `archive` é nulo, o componente nem chega neste caminho, e o marcador aparece
 * como texto comum, que é exatamente o que se quer.
 */

/** Marcadores que a API grava quando a mensagem não é texto. */
const MARCADOR = /^\[[^\]]+\]$/;

/** Nome de arquivo de imagem, que o front recebe quando não houve legenda. */
const NOME_DE_ARQUIVO = /\.(jpe?g|png|gif|webp)$/i;

/**
 * @param {string|null|undefined} texto o campo `message` da mensagem
 * @returns {string} a legenda a exibir, ou string vazia quando não há o que dizer
 */
export const legendaDaImagem = (texto) => {
    const limpo = (texto || '').trim();

    if (limpo === '' || NOME_DE_ARQUIVO.test(limpo) || MARCADOR.test(limpo)) {
        return '';
    }

    return limpo;
};
